import {
    Component,
    ViewChild,
    ComponentFactoryResolver,
    ApplicationRef
} from '@angular/core';
import { ModalsService, ModalBody } from '../modals/Modals.service';
import { TranslationService } from '../translations/Translation.service';
import { GlobalModalContentDirective } from './global-modal-content.directive';

@Component({
    selector: 'global-modal',
    template: `
        <modal [hidden]="!contentBody" class="pi-modal" [ngClass]="className">
            @if (title) {
                <div class="pi-modalHeader">
                    <span class="flex-1">
                        @if (title.linksTo) {
                            <a
                                class="lsg-link"
                                [routerLink]="title.linksTo"
                                (click)="titleClick()"
                            >
                                {{ title.displayString }}
                            </a>
                        } @else {
                            {{ title.displayString }}
                        }
                    </span>
                    <button
                        type="button"
                        class="close"
                        (click)="selfTerminate()"
                        [title]="TR.key('text.common-terms.close')"
                    >
                        <i
                            class="fa fa-close"
                            [title]="TR.key('text.common-terms.close')"
                        ></i>
                    </button>
                </div>
            }
            <div class="pi-modalBody">
                <ng-template notifications></ng-template>
                <ng-template #modalContent global-modal-content></ng-template>
            </div>
        </modal>
    `,
    standalone: false
})
export class GlobalModalComponent {
    @ViewChild(GlobalModalContentDirective, { static: false })
    globalModalContent: GlobalModalContentDirective;

    id: string | number = null;
    className: string;
    title: {
        displayString: string;
        linksTo?: {
            path: string;
            id: string;
        };
    } = null;
    contentBody: ModalBody = null;
    closeCallback: Function = null;

    constructor(
        public TR: TranslationService,
        private modalsService: ModalsService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private app: ApplicationRef
    ) {
        modalsService.topModal$.subscribe((topModalInfo) => {
            if (topModalInfo) {
                this.id = topModalInfo.id;
                this.className = topModalInfo.content.className;
                this.title = topModalInfo.content.TRtitle;
                this.contentBody = topModalInfo.content.body;
                this.closeCallback = topModalInfo.closeCallback
                    ? topModalInfo.closeCallback
                    : null;
                this.setContent();
            } else {
                this.id = '';
                this.title = {
                    displayString: '',
                    linksTo: null
                };
                this.contentBody = null;
                this.globalModalContent.viewContainerRef.clear();
            }
        });
    }

    setContent() {
        const componentFactory =
            this.componentFactoryResolver.resolveComponentFactory(
                this.contentBody.type
            );

        const viewContainerRef = this.globalModalContent.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        if (componentRef.instance.propertiesList) {
            componentRef.instance.propertiesList.forEach((propName) => {
                if (this.contentBody.properties[propName]) {
                    (componentRef.instance as any)[propName] =
                        this.contentBody.properties[propName];
                }
            });
        }
        if (componentRef.instance.outputEvents) {
            componentRef.instance.subscriptions =
                componentRef.instance.outputEvents
                    .filter(
                        (outputEvent) => this.contentBody.events[outputEvent]
                    )
                    .map((outputEvent) =>
                        (componentRef.instance as any)[outputEvent].subscribe(
                            this.contentBody.events[outputEvent]
                        )
                    );
        }
        if (
            componentRef.instance.propertiesList ||
            componentRef.instance.outputEvents
        ) {
            this.app.tick();
        }
    }

    titleClick() {
        if (this.title && this.title.linksTo) {
            this.modalsService.closeModal(this.id);
        }
    }

    selfTerminate() {
        this.modalsService.closeModal(this.id, false);
    }
}
